module.exports = __webpack_public_path__ + "img/logo.f0e912ed.png";